<template>
 <div class="content" id="quote-edit">
    <div class="header">
      <h1>{{ pageTitle }}</h1>
    </div>
    <div class="content-body two-columns">
      <Spin v-if="loading" fix size="large"></Spin>
      <div v-if="quoteGroupInstance">
        <div class="left">
          <div class="block">
            <QuotesGroupForm :type="quoteMethod" :quote-group-instance="quoteGroupInstance"></QuotesGroupForm>
          </div>
        </div>
        <div class="right">
          <div class="block">
            <h3>{{ $t('menu.quote.quote_list') }}</h3>
            <div class="text-align-right"><Button size="small" type="warning" @click="showCreateQuoteForm = true">{{ $t('menu.quote.new_quote') }}</Button></div>
            <ol v-if="relatedQuotes.length > 0" style="margin-left: 15px;">
              <li v-for="q in relatedQuotes" :key="q.id">
                <router-link :to="{ name: 'menu.quote.edit', params: { quoteId: q.id } }" target="_blank">
                  <span>{{ moment(q.created_at).format('YYYY-MM-DD') }}</span>&nbsp;
                  <span>{{ q.number }}</span>&nbsp;
                  <span>{{ q.nsf_phase }}</span>&nbsp;
                  <span v-if="q.data">{{ q.data.quantity }}</span>&nbsp;
                  <span>{{ $t(`quote.status.${q.status}`) }}</span>
                  <span>{{ q.amount }}</span>
                </router-link>
              </li>
            </ol>
            <div v-else>{{ $t('quote.list_is_empty') }}</div>
          </div>
        </div>
      </div>
    </div>
    <Modal v-model="showCreateQuoteForm" :title="$t('menu.quote.new_quote')" footer-hide>
      <QuotesGroupCreateQuoteForm v-if="quoteGroupInstance"
                                  :quote-group-instance="quoteGroupInstance"
                                  @on-saved="handleQuoteCreated">
      </QuotesGroupCreateQuoteForm>
    </Modal>
 </div>
</template>

<script>
import { mapActions } from 'vuex'
import QuotesGroupForm from './components/forms/quotes-group-form'
import QuotesGroupCreateQuoteForm from './components/forms/quotes-group-create-quote-form'
import moment from 'moment'
export default {
  name: "EditQuoteGroup",
  components: {
    QuotesGroupForm,
    QuotesGroupCreateQuoteForm
  },
  data () {
    return {
      loading: false,
      showCreateQuoteForm: false,
      quoteGroupInstance: null,
      relatedQuotes: []
    }
  },
  computed: {
    pageTitle () {
      const name = this.$route.path.split('/')[3]
      let title = this.$t(`menu.quote.edit_${name}_quotes_group`) + ' - ' + this.quoteGroupInstance?.title
      return title
    },
    quoteMethod () {
      return this.$route.path.split('/')[3]
    }
  },
  mounted () {
    this.getQuoteGroupInstance()
    this.getRelatedQuotes()
  },
  methods: {
    ...mapActions(['getQuoteGroup', 'getQuotesFromQuoteGroup']),
    moment,
    getQuoteGroupInstance () {
      this.loading = true
      this.getQuoteGroup(this.$route.params.id)
        .then(resp => {
          this.quoteGroupInstance = resp.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    getRelatedQuotes () {
      this.loadingQuotes = true
      this.getQuotesFromQuoteGroup(this.$route.params.id)
        .then(resp => {
          this.relatedQuotes = resp.data
        })
        .finally(() => {
          this.loadingQuotes = false
        })
    },
    handleQuoteCreated (quote) {
      this.showCreateQuoteForm = false
      this.relatedQuotes.push(quote)
    }
  }
}
</script>
